import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPQantFaq = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "nonzero",
		fill: "none",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M15.8477 1.49525L7.206 9.8489c-.192.192-.4801.192-.7681.096L1.34889 7.1603c-.4801-.288-.4801-1.0562.09602-1.2482L15.5596 1.01516c.2881-.09602.4801.28805.2881.48009z",
			fill: "#32C8DC"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16.4239 1.97505L7.9742 10.4247c-.288.192-.288.5761-.096.7681l2.8806 5.089c.288.4801 1.0562.4801 1.2482-.096L17 2.16709c0-.19204-.2881-.38407-.5761-.19204z",
			fill: "#005AFF"
		})]
	})
});
export default SvgPQantFaq;
